import { createContext, useContext, useEffect, useReducer, useState } from "react";
import { Functions } from "../../helpers/Functions";
import CONFIGURACIONES from "../../util/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
// import { API_URL } from "./AuthTypes.jsx";
// import INIT from "../util/UtilObjectsInit";
// import CONFIG from "../util/UtilApi";
// import { helpFunctions } from "../helpers/helpFunctions.jsx";

// Crear un contexto de autenticación con valor inicial "authenticated: false"
export const AuthContext = createContext({
    // authenticated: false,
    // getAccessToken: () => "",
    // getToken: () => "",
    // saveUser: (userData, mode=1) => {},
    // getUser: () => "",
    // getMenuRender: () => [],
    // getComponentActual: () => "",
    // getTitleLocal: () => "",
    // updateStatusUser: (status) => "",
    checkToken: () => false,
    signOut: () => ""
});

export const AuthProvider = ({ children }) => {
    // Tu lógica de autenticación aquí
    // const [authenticated, setAuthenticated] = useState(false);
    const [accessToken, setAccessToken] = useState("");
    const [authenticated, setAuthenticated] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    
    const location = useLocation();
    const redirect = useNavigate();

    useEffect(() => {
        console.log('exec on login...');
        const timer = setInterval(() => {
            if (location.pathname === '/') return;

            console.log('verificacion cada 10 segundos...');
            const tokenEncrypt = Functions().decryptData(localStorage.getItem('token')??'')
            if (!tokenEncrypt) {
                Functions().signOut(redirect, toast);
                return;
            }

            const decoded = JSON.parse(atob(tokenEncrypt.split('.')[1]));
            const expiration = decoded.exp * 1000; // JWT exp viene en segundos
      
            if (Date.now() >= expiration) {
                Functions().signOut(redirect, toast);
            }
        }, CONFIGURACIONES.INIT.INTERVAL_SESSION);

        return () => clearTimeout(timer);
    }, [location]);

    // const [menu, setMenu] = useState([]);
    // const [permissions, setPermissions] = useState([]);

    // // const [refreshToken, setRefreshToken] = useState("");
    // const [user, setUser] = useState("");

    // useEffect(() => {
    //     checkAuth();
    //     // (async () => {
    //     //     await checkAuth();
    //     // })();
    //     // const fetchData = async () => {
    //     //     console.log('data...')
    //     //     await checkAuth();
    //     // }
    //     // fetchData();
    // },[/*authenticated, accessToken, user*/]);

    // async function requestNewAccessToken(refreshToken) {
    //     try {
    //         const response = await fetch(`${INIT.API_ENDPOINSTS.LOGIN}/RefreshToken`, {
    //             method: "POST",
    //             headers: CONFIG.HEADER_JSON,
    //             body: JSON.stringify({ 
    //                 refreshToken
    //             }), 
    //         });

    //         if(response.ok) {
    //             const json = await response.json();
    //             if(!json.success) {
    //                 localStorage.clear();
    //                 throw new Error(json.errorMessage);
    //             }
    //             return json.result.token;
    //         } else {
    //             localStorage.clear();
    //             throw new Error(response.statusText);
    //         }
    //     } catch(error) {
    //         console.log("Error: "+error);
    //         return null;
    //     }
    // }

    // async function getUserInfo(accessToken) {
    //     try {
    //         const response = await fetch(`${API_URL}/user`, {
    //             method: "GET",
    //             headers: {
    //                 "Content-Type": CONFIG.HEADER_JSON,
    //                 "Authorization": `Bearer ${accessToken}`,
    //             },
    //         });

    //         if(response.ok) {
    //             const json = await response.json();
    //             if(json.error) {
    //                 throw new Error(json.error);
    //             }
    //             return json.body;
    //         } else {
    //             throw new Error(response.statusText);
    //         }
    //     } catch(error) {
    //         console.log("Error: ". error);
    //         return null;
    //     }
    // }

    // function clearContext () {
    //     setAuthenticated(false);
    //     setAccessToken("");
    //     setMenu([]);
    //     setPermissions([]);
    // }

    function checkToken () {
        if (localStorage.length > 0) {
            if(accessToken) {
                return true;
            } else {
                const token = getToken();
                if(token) {
                    const tokenEncrypt = Functions().decryptData(localStorage.getItem('token')??'')
                    const decoded = JSON.parse(atob(tokenEncrypt.split('.')[1]));
                    const expiration = decoded.exp * 1000; // JWT exp viene en segundos
                  
                    const timeout = expiration - Date.now(); // Tiempo que falta
                
                    // let expiredLocal = localStorage.getItem('expira')??'';
                    // const expired = Functions().decryptData(expiredLocal);
     
                    // let timeAct = Math.floor(Date.now() / 1000); //Date.now();
                    if (timeout > 0) {
                        return true;
                    }
                }

                return false;
            }
        } 

        return false;
    }

    function getToken() {
        const token = localStorage.getItem('token')??'';
        const tokenData= Functions().decryptData(token);
     
        if(tokenData) {
            return tokenData;
        }
        return null;
    }

    function getUser() {
        let token = getToken();
        let decoded = jwtDecode(token);
        let data = JSON.parse(JSON.stringify(decoded));
        console.log('data', data.user);
        
        return {
            'user': data.user??null,
            'area': data.area??null,
            'cargo': data.cargo??null,
            'colaborador': data.colaborador??null,
            'permisos': data.permisos??[]
        };
    }

    function getMenu() {
        let token = getToken();
        let decoded = jwtDecode(token);
        let data = JSON.parse(JSON.stringify(decoded));
        // console.log('data', data.user);

        return data.menu??[];
    }

    function getZonasAgencias() {
        let token = getToken();
        let decoded = jwtDecode(token);
        let data = JSON.parse(JSON.stringify(decoded));

        return {'zonas': data.zonas, 'agencias': data.agencias};
    }

    function signOut() {
        localStorage.clear();
        window.location.hash="no-back-button";
        window.location.hash="Again-No-back-button"
        // window.location.href = '/'
    }

    // async function checkAuth() {
    //     // console.log('accessToken', accessToken);
        
    //     if(accessToken) {
    //         //el usuario esta autenticado
    //     } else {
    //         //el usuario NO esta autenticado
    //         // return getToken();
    //         const token = getToken();
    //         // console.log('token', token)
    //         setAuthenticated(false);
    //         if(token) {
    //             let expiredLocal = localStorage.getItem("expiredToken")??'';
    //             const expired = helpFunctions().decryptData(expiredLocal, CONFIG.TOKEN_SECRET);
     
    //             let timeAct = Math.floor(Date.now() / 1000); //Date.now();
    //             // console.log('time', timeAct);
    //             // console.log('expired', expired);
    //             // console.log('time | expired', expired-timeAct);
    //             if (expired-timeAct > 0) {
    //                 // console.log('que fue..')
    //                 setAuthenticated(true);
    //             }
    //         }
    //     }
    // }

    // function saveSessionInfo(userInfo, accessToken, refreshToken, expiredTime) {
    //     setAccessToken(accessToken);
    //     const encrypToken = helpFunctions().encrypData(accessToken, CONFIG.TOKEN_SECRET);
    //     const encrypRefreshToken = helpFunctions().encrypData(refreshToken, CONFIG.TOKEN_SECRET);
    //     const encrypExpiredTime = helpFunctions().encrypData(expiredTime, CONFIG.TOKEN_SECRET);
      
    //     localStorage.setItem("token", encrypToken);
    //     localStorage.setItem("refreshToken", encrypRefreshToken);
    //     localStorage.setItem("expiredToken", encrypExpiredTime);
    //     if (userInfo) { 
    //         setUser(userInfo) 
    //         const encrypUserInfo = helpFunctions().encrypData(JSON.stringify(userInfo), CONFIG.TOKEN_SECRET);
        
    //         localStorage.setItem("user", encrypUserInfo)
    //     };
    //     setAuthenticated(true);
    // }

    // function getAccessToken() {
    //     return accessToken;
    // }

    // function getToken() {
    //     const refreshToken = localStorage.getItem("refreshToken")??'';
    //     // console.log('refresh', refreshToken)
    //     const tokenData= helpFunctions().decryptData(refreshToken, CONFIG.TOKEN_SECRET);
     
    //     // const tokenData = decryptedRefreshToken;
    //     if(tokenData) {
    //         return tokenData;
    //     }
    //     return null;
    // }

    // function saveUser(userData, mode = 1) {
    //     // if (mode === 'RL') { localStorage.removeItem('textTitle'); }
    //     saveSessionInfo(userData.dataUser, 
    //         userData.token, 
    //         userData.refreshToken,
    //         userData.expiredTime);
    // }

    // function updateStatusUser(status) {
    //     const userUpdate = {...user, 'estadoId': status};
    //     setUser(userUpdate) 
    //     const encrypUserInfo = helpFunctions().encrypData(JSON.stringify(userUpdate), CONFIG.TOKEN_SECRET);
    //     localStorage.setItem("user", encrypUserInfo)
    // }

    // function saveMenu(menuData) {
    //     setMenu(menuData);
    //     const encrypMenuData = helpFunctions().encrypData(JSON.stringify(menuData), CONFIG.TOKEN_SECRET);
    //     localStorage.setItem("menu", encrypMenuData);
    // }

    // function savePermissions (permissionsData) {
    //     setPermissions(permissionsData);
    //     const encrypPermissionsData = helpFunctions().encrypData(JSON.stringify(permissionsData), CONFIG.TOKEN_SECRET);
    //     localStorage.setItem("permissions", encrypPermissionsData);
    // }

    // function getUser() {
    //     let userSession = localStorage.getItem("user");
    //     return JSON.parse(userSession != null?helpFunctions().decryptData(userSession, CONFIG.TOKEN_SECRET):'[]');
    //     // return user;
    // }

    // function getMenuRender () {
    //     let menuSession = localStorage.getItem("menuRender");
    //     return JSON.parse(menuSession != null?helpFunctions().decryptData(menuSession, CONFIG.TOKEN_SECRET):'[]');
    // }

    // function getComponentActual () {
    //     let componentSession = localStorage.getItem("componentAct");
    //     return (componentSession != null?helpFunctions().decryptData(componentSession, CONFIG.TOKEN_SECRET):'');
    // }
    // function getMenuPrincipal () {
    //     let objSession = localStorage.getItem("menu");
    //     return JSON.parse(objSession != null? helpFunctions().decryptData(objSession, CONFIG.TOKEN_SECRET):'[]');
    // }
    // function getPermissions () {
    //     let objSession = localStorage.getItem("permissions");
    //     return JSON.parse(objSession != null? helpFunctions().decryptData(objSession, CONFIG.TOKEN_SECRET):'[]');
    // }
    // function getTitleLocal () {
    //     let obj = localStorage.getItem("textTitle");
    //     return obj!=null?obj:'Inicio';
    // }
    return (
        <AuthContext.Provider 
        value={
            {checkToken, signOut, getUser, getMenu, getZonasAgencias }
        }>
            {children} {/* Renderiza los componentes hijos */}
        </AuthContext.Provider>
    );
};